const ALLOWED_EMAILS = ['adam@thermal-systems.co.uk', 'dave@thermal-systems.co.uk'];
const STORAGE_KEY = 'ts1_signal_test_sensors';

export function isSignalTestAllowed(email: string | undefined): boolean {
  return !!email && ALLOWED_EMAILS.includes(email.toLowerCase());
}

export function readSignalTestSensors(): Set<number> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? new Set(JSON.parse(raw) as number[]) : new Set();
  } catch {
    return new Set();
  }
}

function writeSignalTestSensors(ids: Set<number>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
}

export function toggleSignalTestSensor(id: number): Set<number> {
  const ids = readSignalTestSensors();
  ids.has(id) ? ids.delete(id) : ids.add(id);
  writeSignalTestSensors(ids);
  return new Set(ids);
}
